import React from 'react';
import { LoginCallback as OktaLoginCallback } from '@okta/okta-react';

interface OktaError extends Error {
  errorCode?: string;
  errorSummary?: string;
}

const LoginCallback: React.FC = () => {
  const renderError = (props: { error: Error }) => {
    const { error } = props;
    if (error) {
      const oktaError = error as OktaError;
      const { errorCode, errorSummary } = oktaError;

      if (errorCode === 'access_denied' && errorSummary === 'The resource owner or authorization server denied the request.') {
        return (
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Access Denied</h2>
            <p>You do not have permission to access this application.</p>
            <p>Please contact your administrator for access.</p>
          </div>
        );
      }
      
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h2>Authentication Error</h2>
          <p>An error occurred during login. Please try again.</p>
          <p>{error.message}</p>
        </div>
      );
    }
    return null;
  };

  return <OktaLoginCallback errorComponent={renderError} />;
};

export default LoginCallback;
